import type { TFormProps } from "@/ui/components/form/Form";
import type { TInputProps } from "@/ui/components/form/Input";
import type { TButtonProps } from "@/ui/components/primitives/Button";
import type { SubmitEventHandler } from "react";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const REQUEST_LOGIN_CODE_SUBMIT_DEFAULTS = {
  variant: "secondary",
  width: "fill",
} satisfies Pick<TRequestLoginCodeSubmitProps, "variant" | "width">;

export const REQUEST_LOGIN_CODE_FIELD_CLASS = "w-full [&_[data-component='Label']]:font-sys-heading [&_[data-component='Label']]:leading-sys-1-3";

/*-------------------------------------
|  Types
-------------------------------------*/

export type TRequestLoginCodeInputProps = Omit<
  TInputProps,
  | "aria-describedby"
  | "defaultValue"
  | "id"
  | "label"
  | "name"
  | "onBlur"
  | "onChange"
  | "type"
  | "value"
> & {
  value: string;
  onValueChange: (value: string) => void;
  onBlur?: () => void;
  label?: string;
};

export type TRequestLoginCodeSubmitProps = Omit<
  TButtonProps,
  "children" | "type"
> & {
  label?: string;
};

export type TRequestLoginCodeMessages = {
  emailLabel: string;
  emailPlaceholder: string;
  submitLabel: string;
};

export type TRequestLoginCodeTranslate = (
  key: keyof TRequestLoginCodeMessages,
) => string;

export type TRequestLoginCodeProps = Omit<
  TFormProps,
  "children" | "onSubmit"
> & {
  email: TRequestLoginCodeInputProps;
  submit?: TRequestLoginCodeSubmitProps;
  onSubmit: SubmitEventHandler<HTMLFormElement>;
};
